module.exports = __webpack_public_path__ + "images/emoji/zzz.552763212fb5cd927564.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/zzz.png
// module id = xNB0
// module chunks = 2